var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProgressDots',{staticStyle:{"font-size":"15px"},attrs:{"step":_vm.step,"steps":[
    'Create your account',
    'Setup your portal',
    'Upload your design',
    'Share with your team'
]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e6a72f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SignUpProgress.vue
// module id = YHaQ
// module chunks = 1